import { render, staticRenderFns } from "./point-list-search.vue?vue&type=template&id=5067a916&"
import script from "./point-list-search.vue?vue&type=script&lang=js&"
export * from "./point-list-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports